<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCalcCost"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        >
        </Input>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="20"
          @on-change="loadCalcCost"
          show-total
          simple
          style="margin-right: 24px"
        />
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :columns="columns"
        border
        :data="calcCostList"
        :height="tableHeight"
      >
      </Table>
    </div>
    <CalcSalesDetailDrawer ref="CalcSalesDetailDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import { arrayIntersection } from "@/utils";
import CalcSalesDetailDrawer from "../CaclSalesCost/CalcSalesDetailDrawer.vue";
import _ from "lodash";

export default {
  name: "CalcCostPage",
  components: {
    CalcSalesDetailDrawer,
  },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      filterQuery: {},
      limit: 20,
      tableHeight: 300,
      columns: [
        {
          title: "配方NoId",
          key: "NoId",
          align: "left",
          fixed: "left",
          width: 100,
          render: (h, params) => {
            return h("div", params.row.recipe ? params.row.recipe.NoId : "");
          },
        },
        {
          title: "配方日期",
          key: "recipeDate",
          align: "left",
          fixed: "left",
          width: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.recipe
                ? dayjs(params.row.recipe.createdAt).format("MM-DD")
                : ""
            );
          },
        },
        {
          title: "简称",
          key: "abbr",
          minWidth: 150,
          maxWidth: 650,
          fixed: "left",
          render: (h, params) => {
            return h(
              "div",
              {
                style: { color: "#42b983", cursor: "pointer" },
                on: {
                  click: () => {
                    if (params.row.calcSalesCost) {
                      this.$refs.CalcSalesDetailDrawer.openDrawer(params.row);
                    } else {
                      this.$Message.error("该项目没有核算");
                    }
                  },
                },
              },
              params.row.sales.abbr
            );
          },
        },
        {
          title: "客户",
          key: "customer",
          minWidth: 250,
          maxWidth: 650,
          render: (h, params) => {
            return h("div", params.row.sales.customer.name);
          },
        },
        {
          title: "材料",
          key: "material",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("div", params.row.sales.material.model);
          },
        },
        {
          title: "材料成本",
          key: "materialCost",
          align: "right",
          sortable: "custom",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "div",
              params.row.materialCost ? parseInt(params.row.materialCost) : ""
            );
          },
        },
        {
          title: "运输费",
          key: "transCost",
          align: "right",
          sortable: "custom",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.transCost ? parseInt(params.row.transCost) : ""
            );
          },
        },
        {
          title: "业务费",
          key: "promoFee",
          align: "right",
          sortable: "custom",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.promoFee ? parseInt(params.row.promoFee) : ""
            );
          },
        },
        {
          title: "复配费",
          key: "manufactCost",
          align: "right",
          sortable: "custom",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.manufactCost ? parseInt(params.row.manufactCost) : ""
            );
          },
        },
        {
          title: "税费",
          key: "tax",
          align: "right",
          sortable: "custom",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.tax ? parseInt(params.row.tax) : "");
          },
        },
        {
          title: "合计成本",
          key: "agingCost",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.totalCost ? parseInt(params.row.totalCost) : ""
            );
          },
        },
        {
          title: "售价",
          key: "price",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.price ? parseInt(params.row.price) : "");
          },
        },
        {
          title: "利润",
          key: "profit",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.profit ? parseInt(params.row.profit) : ""
            );
          },
        },
        {
          title: "利润率",
          key: "profitRate",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.profitRate
                ? (params.row.profitRate*100).toFixed(2) + "%"
                : ""
            );
          },
        },
        {
          title: "账期",
          key: "estAging",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.estAging ? params.row.estAging : "");
          },
        },
        {
          title: "资后成本",
          key: "totalCostWithAging",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.totalCostWithAging
                ? parseInt(params.row.totalCostWithAging)
                : ""
            );
          },
        },
        {
          title: "资后利润",
          key: "profitAfterAging",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.profitAfterAging
                ? parseInt(params.row.profitAfterAging)
                : ""
            );
          },
        },
        {
          title: "资利润率",
          key: "profitRateAfterAging",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.profitRateAfterAging
                ? (params.row.profitRateAfterAging * 100).toFixed(2) + "%"
                : ""
            );
          },
        },
        {
          title: "年收益率",
          key: "annualizedRateOfReturns",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.annualizedRateOfReturns
                ? (params.row.annualizedRateOfReturns * 100).toFixed(2) + "%"
                : ""
            );
          },
        },
      ],
    };
  },
  computed: mapState({
    calcCostList: (state) => state.caclSalesCost.calcCost,
    totalRows: (state) => state.caclSalesCost.calcCostTotal,
  }),
  methods: {
    ...mapActions({
      getCalcSalesCost: "caclSalesCost/getCalcSalesCostAction",
    }),
    async loadCalcCost(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        await this.getCalcSalesCost(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchCalcCost: _.debounce(function () {
      this.page = 0;
      this.loadCalcCost();
    }, 1000),
  },
  created() {
    this.loadCalcCost();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-right
  display flex
  align-items center
  justify-content space-between

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>